import FileType from '@/components/FileType';
import s from './style.module.scss';
import { Tooltip } from 'antd';
import { formatFileSize } from '@/utils';
import { Display } from '@/components/Display/Display';
import { fileStatusMap } from '@/utils/Page/constant';
import { CloseCircleFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { fileTypeMap } from '@/utils/Page/constant';
import { ImageViewer, Image, Skeleton } from 'antd-mobile';
import MobileImgage from './Image';
import FileInfo from './FileInfo';
import UseSendFile from '@/pages/hooks/useSendFile';
import { fileStatusDic } from '@/utils/Page/constant';
import { getFileIcon } from '@/components/FileType';
const SendFile = ({ file, index, close, changeFile, needParse = false }) => {
    const changeFileInfo = (data) => {
        // console.log(data, 'data', index, file);
        changeFile(index, { ...file, ...data });
    };
    const { parseResult } = UseSendFile({ file, changeFileInfo, needParse });
    useEffect(() => {
        //接口返回的文件状态和解析状态都是status字段，前端处理下
        let { status, ...result } = parseResult;

        changeFileInfo({ ...result, parse_status: status });
    }, [parseResult]);

    return (
        <>
            <div className={s['file-item']} data-type={file.type}>
                <span
                    className={s['close']}
                    onClick={() => {
                        close(index);
                    }}
                >
                    <CloseCircleFilled />
                </span>
                <Display show={file.type === fileTypeMap.img}>
                    <div className={s['img-type-wrap']}>
                        <div className={s['left']}>
                            <Display show={file.status === fileStatusDic.ing}>
                                <Skeleton className={s['skeleton']} animated />
                            </Display>
                            <Display show={file.status !== fileStatusDic.ing}>
                                <MobileImgage canClickImage={false} file={file}></MobileImgage>
                            </Display>
                        </div>
                        <div className={s['right']}>
                            <FileInfo file={file}></FileInfo>
                        </div>
                    </div>
                </Display>
                <Display show={file.type === fileTypeMap.file || file.type === fileTypeMap.link}>
                    <div className={s['file-type-wrap']}>
                        <FileInfo file={file}></FileInfo>
                    </div>
                </Display>
            </div>
        </>
    );
};
export default SendFile;
